import { fabric } from "fabric";
import reduxStore from "../../configureEnvStore";
import { DEVICE_TYPES, ENABLED, EXTRACT_TEXT_VIEW, MARKUP_VIEW, MEASUREMENT_VIEW } from "../../constants/Constants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import Localize from "../../locale/Localize";
import {
    setAutoLivePointerInProgress,
    setLivePointerColors,
    setLivePointerInProgress,
    setPointerOn,
    setPointerStCode,
} from "../../reducers/livePointer-reducer";
import { LogFirebase } from "../../services/firestore";
import { AppIsStreaming, getUserDetailsById, isvideoenabled, waitForVideoElement } from "../Twilio/Room/roomFunction";
import CustomToast from "../UI/customToast";
import { checkZoomLevelForLivePointerCanvas, toggleFeaturesOnPointerOn } from "./LivePointerUtils";
import { AGENTDEFAULTCOLOR, pointerStatus, STATUS } from "../../constants/LivePointerConstants";
import googleEvent from "../../services/googleEvent";
import { sendDataTrack, sendMsgForPointer } from "../../shared/dataTrackFunction";
import { NOTIFICATION_TYPES } from "../../constants/DataTrackNotificationConstants";
import { setShowOrientationModal } from "../../reducers/extractText-reducer";
import navigatorService from "../../services/navigatorService";
import zoomService from "../../services/zoomService";
import { setIsLocationOnVideoIsVisible } from "../../reducers/common-reducer";
import { isSilentObserverAvailable } from "../../shared/function";
import { EVENT_NAME } from "../../constants/GTagConstants";
import extractTextService from "../../services/extractTextService";
import arMarkupService from "../../services/MarkupService/arMarkupService";

let vcanvas = null;

class LivePointerService {
    annpoint = null;
    local_pointer = null;
    remote_pointers = [];
    userId = null;
    lpOrientation = 0;
    pointerLiveStream = false;

    getVcanvas() {
        return vcanvas;
    }

    getLivePointerFeatureFlagValue = () => {
        return PublicVariables.featureFlag.SHOWMELIVECURSOR;
    };

    // Check if markup, OCR, measurement, or AR markup is currently in progress (agent showing exit popup or in active view)
    isConflictingFeatureInProgress = () => {
        const { callannview, confirmExitMarkup, markupInprogress } = reduxStore.getState().markup;
        const { extractTextInprogress } = reduxStore.getState().extractText;
        const { measurementView } = reduxStore.getState().measurement;
        const isOCRActive = extractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW || extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW;
        const isMarkupActive = markupInprogress === MARKUP_VIEW.PREPARE_VIEW || markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW;
        const isMeasurementActive = measurementView === MEASUREMENT_VIEW.PREPARE_VIEW || measurementView === MEASUREMENT_VIEW.START_MEASUREMENT_VIEW;
        return callannview || confirmExitMarkup || isOCRActive || isMarkupActive || isMeasurementActive || arMarkupService.checkARMarkupIsOngoing();
    };

    isLivePointerButtonAvailable = () => {
        return this.getLivePointerFeatureFlagValue() == ENABLED && !isSilentObserverAvailable();
    };

    checkLivePointerButtonEnabled = () => {
        const { livePointerInProgress, autoLivePointerInProgress } = reduxStore.getState().livePointer;
        const { allowPointer, expandView } = reduxStore.getState().commonReducer;
        const { screenSharingUsers, videoStreamingUsers } = reduxStore.getState().twilioEvents;
        const { isEmpty } = require("lodash");
        const isvideoenabled = !isEmpty(videoStreamingUsers) || !isEmpty(screenSharingUsers);
        const { extractTextInprogress } = reduxStore.getState().extractText;
        const ocrinprogress = extractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW || extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW;
        const arMarkupOngoing = arMarkupService.checkARMarkupIsOngoing();
        const result =
            expandView &&
            !livePointerInProgress &&
            !autoLivePointerInProgress &&
            allowPointer &&
            isvideoenabled &&
            !ocrinprogress &&
            !arMarkupOngoing;

        // Debug logging for button state issues
        if (!result) {
            console.log("checkLivePointerButtonEnabled: DISABLED", {
                expandView,
                livePointerInProgress,
                autoLivePointerInProgress,
                allowPointer,
                isvideoenabled,
                ocrinprogress,
                arMarkupOngoing,
            });
        }
        return result;
    };

    checkLivePointerStatus = () => {
        const { pointerOn } = reduxStore.getState().livePointer;
        return pointerOn;
    };

    disableLivepointer() {
        reduxStore.dispatch(setPointerStCode(pointerStatus.DISABLED));
    }

    toggleLivePointer = (fromWhere, msg, toastmsg) => {
        const { pointerOn, livePointerInProgress } = reduxStore.getState().livePointer;

        console.log("toggleLivePointer called:", { fromWhere, pointerOn, livePointerInProgress, msg: msg?.livepointer_data });

        let livePointerData = {};
        if (msg != undefined) {
            livePointerData = JSON.parse(msg != undefined ? msg?.livepointer_data : null);
            livePointerData.POINTERSTATUS = livePointerData?.POINTERSTATUS?.toString();
            reduxStore.dispatch(setPointerStCode(livePointerData?.POINTERSTATUS));
            // do nothing if old support user data track recive with pointer status '3' (ENABLED)
            if (livePointerData.POINTERSTATUS == pointerStatus.ENABLED) {
                console.log("pointer enabled");
                LogFirebase("LivePointer", "toggleLivePointer - received_enabled_status", true);
                return;
            } else if (livePointerData.POINTERSTATUS == pointerStatus.DISABLED) {
                if (pointerOn) {
                    LogFirebase("LivePointer", "toggleLivePointer - received_disabled_turning_off", true);
                    this.turnOffLivePointer();
                }
                return;
            }
            if (livePointerData.POINTERSTATUS == pointerStatus.ON && pointerOn && vcanvas) {
                console.log("::pointer is already On");
                LogFirebase("LivePointer", "toggleLivePointer - already_on_skipping", true);
                return;
            }
            // Skip ON message if markup/OCR is in progress (e.g., agent has exit popup showing)
            // The pointer will be properly activated when markup/OCR exits via toggleannotationdiv
            if (livePointerData.POINTERSTATUS == pointerStatus.ON && this.isConflictingFeatureInProgress()) {
                console.log("toggleLivePointer: Skipping ON - markup/OCR in progress, will activate after exit");
                LogFirebase("LivePointer", "toggleLivePointer - skip_conflicting_feature_in_progress", {
                    markup: reduxStore.getState().markup.annotation,
                    ocr: reduxStore.getState().ocr.ocrinprogress,
                });
                // Store colors for later use when markup exits
                if (livePointerData.USERCOLORS) {
                    reduxStore.dispatch(setLivePointerColors(livePointerData.USERCOLORS));
                }
                return;
            }
        }
        if (!livePointerInProgress) {
            console.log("toggleLivePointer: entering main block, setting livePointerInProgress=true");
            reduxStore.dispatch(setLivePointerInProgress(true));
            if (fromWhere) {
                LogFirebase("LivePointer", "received_msg", livePointerData?.POINTERSTATUS);

                if (livePointerData.POINTERSTATUS == pointerStatus.OFF) {
                    LogFirebase("LivePointer", "status_off_received", true);
                    this.turnOffLivePointer(false, msg?.show_toast);
                } else if (livePointerData.POINTERSTATUS == pointerStatus.ON) {
                    // Double-check markup/OCR not in progress before activating
                    if (this.isConflictingFeatureInProgress()) {
                        console.log("toggleLivePointer: Skipping canvas creation - markup/OCR still in progress");
                        reduxStore.dispatch(setLivePointerInProgress(false));
                        // Store colors for later use when markup exits
                        if (livePointerData.USERCOLORS) {
                            reduxStore.dispatch(setLivePointerColors(livePointerData.USERCOLORS));
                        }
                        return;
                    }
                    setTimeout(() => {
                        // Final check before canvas creation
                        if (this.isConflictingFeatureInProgress()) {
                            console.log("toggleLivePointer: Skipping canvas creation after timeout - markup/OCR still in progress");
                            reduxStore.dispatch(setLivePointerInProgress(false));
                            return;
                        }
                        LogFirebase("LivePointer", "status_on_canvas_creating", true);
                        reduxStore.dispatch(setPointerOn(true));
                        reduxStore.dispatch(setLivePointerInProgress(false));
                        reduxStore.dispatch(setLivePointerColors(livePointerData.USERCOLORS));
                        this.prepareCanvasForLivePointer(msg?.show_toast);
                    }, 1500);
                }
            } else {
                if (pointerOn) {
                    // turn off live pointer
                    LogFirebase("LivePointer", "user_toggled_off", true);
                    googleEvent.logEvent(EVENT_NAME.STOPPED_LIVE_POINTER);
                    this.turnOffLivePointer(true, toastmsg);
                } else {
                    // turn on live pointer
                    LogFirebase("LivePointer", "user_toggled_on", true);
                    googleEvent.logEvent(EVENT_NAME.STARTED_LIVE_POINTER);
                    sendMsgForPointer(undefined, toastmsg);
                    setTimeout(() => {
                        reduxStore.dispatch(setPointerOn(true));
                        reduxStore.dispatch(setLivePointerInProgress(false));
                        this.prepareCanvasForLivePointer(toastmsg);
                    }, 1500);
                }
            }
        } else {
            console.log("toggleLivePointer: BLOCKED - livePointerInProgress is true");
        }
    };

    canvasCreation(fromWhere, fromZoom) {
        // Safety check - canvas may have been disposed if user collapsed view or turned off pointer
        if (!vcanvas) {
            console.log("canvasCreation: vcanvas is null, skipping");
            return;
        }

        const { streamingPartiIdentity } = reduxStore.getState().twilioEvents;
        const { currentZoom } = reduxStore.getState().commonReducer;
        const userDetails = getUserDetailsById(streamingPartiIdentity);
        const isBrowserDevice =
            userDetails?.device_type === DEVICE_TYPES.ANDROID_BROWSER ||
            userDetails?.device_type === DEVICE_TYPES.IOS_BROWSER ||
            userDetails?.device_type === DEVICE_TYPES.DESKTOP;

        if (isBrowserDevice) {
            checkZoomLevelForLivePointerCanvas(fromZoom);
        } else {
            checkZoomLevelForLivePointerCanvas();
        }
        vcanvas.selection = false;

        this.lpOrientation = navigatorService.getOrientation();
        LogFirebase("LivePointer", "canvas_ready", { orientation: this.lpOrientation });
        if (!isSilentObserverAvailable()) {
            if (fromZoom == "fromZoom") {
                this.moveLivePointerForLocal(currentZoom);
            } else {
                this.moveLivePointerForLocal();
            }
        }
        extractTextService.closeAllModel();
        if (fromWhere == "1") {
            CustomToast.success(Localize[PublicVariables.currentLanguageObj.languageCode]["live_pointer_enabled_message"]);
        }
    }

    prepareCanvasForLivePointer(fromWhere, fromZoom) {
        toggleFeaturesOnPointerOn();
        AppIsStreaming().then(
            () => {
                this.pointerLiveStream = true;
            },
            () => {
                this.pointerLiveStream = false;
            }
        );
        let canvas = document.createElement("canvas");
        canvas.setAttribute("style", "position:absolute;");
        canvas.id = "livecursorCanvas";

        document.getElementById("canvasContainer")?.appendChild(canvas);
        vcanvas = null;
        vcanvas = new fabric.Canvas("livecursorCanvas");
        waitForVideoElement()
            .then((videoElement) => {
                LogFirebase("AutoLivePointer", "video_element_found", {
                    readyState: videoElement?.readyState,
                    videoWidth: videoElement?.videoWidth,
                    videoHeight: videoElement?.videoHeight,
                });
                this.setCanvasSize(fromWhere, fromZoom, videoElement);
            })
            .catch((error) => {
                LogFirebase("AutoLivePointer", "video_element_not_found", { errorMessage: error?.message || String(error) });
                // Cleanup flags on error to prevent button from staying disabled
                reduxStore.dispatch(setAutoLivePointerInProgress(false));
                reduxStore.dispatch(setLivePointerInProgress(false));
                reduxStore.dispatch(setPointerOn(false));
            });
    }

    setCanvasSize(fromWhere, fromZoom, videoElement) {
        // Wait for video to have actual dimensions before setting canvas size
        const waitForVideoDimensions = (retries = 50, interval = 100) => {
            const expandedVideoContainer = document.getElementById("expandedVideo");
            const actualVideoElement = videoElement || expandedVideoContainer?.querySelector("video");
            const videoRect = actualVideoElement?.getBoundingClientRect();
            const videoHasLoaded = actualVideoElement?.videoWidth > 0 && actualVideoElement?.videoHeight > 0;

            let width = videoRect?.width || 0;
            let height = videoRect?.height || 0;

            if (width > 0 && height > 0 && videoHasLoaded) {
                console.log("Live pointer: Canvas dimensions ready", {
                    getBoundingClientRectWidth: width,
                    getBoundingClientRectHeight: height,
                    videoWidth: actualVideoElement?.videoWidth,
                    videoHeight: actualVideoElement?.videoHeight,
                });
                LogFirebase("AutoLivePointer", "canvas_size_set", {
                    getBoundingClientRectWidth: width,
                    getBoundingClientRectHeight: height,
                    videoWidth: actualVideoElement?.videoWidth,
                    videoHeight: actualVideoElement?.videoHeight,
                });
                vcanvas?.setWidth(width);
                vcanvas?.setHeight(height);
                this.canvasCreation(fromWhere, fromZoom);
            } else if (retries > 0) {
                console.log("Live pointer: Waiting for video dimensions, retries left:", retries, {
                    width,
                    height,
                    videoHasLoaded,
                    videoWidth: actualVideoElement?.videoWidth,
                    videoHeight: actualVideoElement?.videoHeight,
                });
                setTimeout(() => waitForVideoDimensions(retries - 1, interval), interval);
            } else {
                const containerRect = expandedVideoContainer?.getBoundingClientRect();
                const fallbackWidth = containerRect?.width || 640;
                const fallbackHeight = containerRect?.height || 480;
                console.log("Live pointer: Using fallback dimensions", { fallbackWidth, fallbackHeight });
                vcanvas?.setWidth(fallbackWidth);
                vcanvas?.setHeight(fallbackHeight);
                this.canvasCreation(fromWhere, fromZoom);
                LogFirebase("AutoLivePointer", "canvas_size_fallback", { fallbackWidth, fallbackHeight });
            }
        };

        waitForVideoDimensions();
    }

    turnOffLivePointer(sendAckToParticipants = false, showtoast) {
        const { livePointerColors, pointerOn, autoLivePointerInProgress } = reduxStore.getState().livePointer;

        LogFirebase("LivePointer", "turn_off", {
            pointerOn: pointerOn,
            sendAck: sendAckToParticipants,
            autoLivePointerInProgress: autoLivePointerInProgress,
        });

        reduxStore.dispatch(setPointerOn(false));
        reduxStore.dispatch(setShowOrientationModal(false));
        reduxStore.dispatch(setPointerStCode(pointerStatus.OFF));
        reduxStore.dispatch(setLivePointerInProgress(false));
        reduxStore.dispatch(setAutoLivePointerInProgress(false));
        if (vcanvas) {
            vcanvas.dispose();
        }
        vcanvas = null;
        if (document.getElementById("canvasContainer")) {
            document.getElementById("canvasContainer").innerHTML = "";
        }

        this.remote_pointers = [];
        this.local_pointer = null;
        this.toggleFeaturesOnPointerOff();
        if (showtoast == undefined) {
            showtoast = "0";
        }
        if (sendAckToParticipants) {
            const msg = {
                notification_type: NOTIFICATION_TYPES.LIVEPOINTER.STATUS_START_STOP,
                identity: CALL_DATA.localIdentity,
                device_type: GLOBAL_MEETING_DATA.device_type,
                oldAppAutoLP: "0",
                show_toast: showtoast,
                livepointer_data: JSON.stringify({ USERCOLORS: livePointerColors, POINTERSTATUS: parseInt(pointerStatus.OFF) }),
            };
            sendDataTrack(msg);
            console.log("STATUS_START_STOP_send_: ", msg, "Status: ", parseInt(pointerStatus.OFF));
        }
        if (showtoast == "1") {
            CustomToast.success(Localize[PublicVariables.currentLanguageObj.languageCode]["live_pointer_disabled_message"]);
        }
    }

    createPointerShape(x, y, color, scale) {
        const pointerPath = "M 0 0 L 0 24 L 6 18 L 10 28 L 14 26 L 10 16 L 18 16 Z";

        const pointer = new fabric.Path(pointerPath, {
            left: x,
            top: y,
            fill: color,
            stroke: "#FFFFFF",
            strokeWidth: 1.5,
            hasBorders: false,
            hasControls: false,
            selectable: false,
            evented: false,
            originX: "left",
            originY: "top",
            scaleX: scale,
            scaleY: scale,
            objectCaching: true,
        });

        pointer.set(
            "shadow",
            new fabric.Shadow({
                blur: 4,
                offsetX: 1,
                offsetY: 2,
                color: "#00000040",
            })
        );

        return pointer;
    }

    moveLivePointerForLocal(from) {
        const { livePointerColors } = reduxStore.getState().livePointer;

        let localColor = "";
        let pointerScale = 1;
        if (GLOBAL_MEETING_DATA.isAgent) {
            localColor = AGENTDEFAULTCOLOR;
        } else {
            localColor = livePointerColors[CALL_DATA.localIdentity];
        }
        if (from == undefined || (from != undefined && from == "1")) {
            pointerScale = 1;
        } else if (from != undefined && from == "2") {
            pointerScale = 0.7;
        } else if (from != undefined && from == "3") {
            pointerScale = 0.5;
        }
        this.local_pointer = null;

        // Hide the browser's default cursor over the canvas
        vcanvas.defaultCursor = "none";
        vcanvas.hoverCursor = "none";
        vcanvas.moveCursor = "none";

        // Optimize: Skip target finding during mouse move for better performance
        vcanvas.skipTargetFind = true;

        vcanvas.on("mouse:move", (o) => {
            let pointer = vcanvas?.getPointer(o.e);

            if (this.local_pointer == null) {
                this.local_pointer = this.createPointerShape(pointer?.x, pointer?.y, localColor, pointerScale);
                vcanvas?.add(this.local_pointer);
            }

            let pointerValue = vcanvas.getPointer(o.e);
            this.local_pointer.set({ left: pointerValue.x, top: pointerValue.y });
            vcanvas.renderAll();

            const msg = {
                notification_type: NOTIFICATION_TYPES.LIVEPOINTER.POINT,
                identity: CALL_DATA.localIdentity,
                device_type: GLOBAL_MEETING_DATA.device_type,
                annotation_point: JSON.stringify({
                    XPOINTS: parseFloat(pointer.x),
                    YPOINTS: parseFloat(pointer.y),
                    HEIGHT: vcanvas.getHeight(),
                    WIDTH: vcanvas.getWidth(),
                    COLOR: localColor,
                    IDENTITY: CALL_DATA.localIdentity,
                }),
            };

            const height = vcanvas.getHeight();
            const Width = vcanvas.getWidth();
            if (vcanvas && height != null && Width != null) {
                sendDataTrack(msg);
            }
        });
    }

    moveLivePointerForRemote(msg) {
        const { streamingPartiIdentity } = reduxStore.getState().twilioEvents;
        const { currentZoom } = reduxStore.getState().commonReducer;
        if (!this.pointerLiveStream) {
            this.annpoint = JSON.parse(msg?.annotation_point ? msg.annotation_point : null);
            this.userId = this.annpoint.IDENTITY;
            let points = [];
            let pointerScale = 1;

            if (vcanvas != null) {
                let mainwidth = vcanvas.getWidth();
                let mainheight = vcanvas.getHeight();

                if (mainwidth <= 0 || mainheight <= 0) {
                    const expandedVideoContainer = document.getElementById("expandedVideo");
                    const videoElement = expandedVideoContainer?.querySelector("video");
                    const videoRect = videoElement?.getBoundingClientRect();

                    mainwidth = videoRect?.width || this.annpoint.WIDTH;
                    mainheight = videoRect?.height || this.annpoint.HEIGHT;

                    if (mainwidth > 0 && mainheight > 0) {
                        console.log("Live pointer remote: Updating canvas dimensions", { mainwidth, mainheight });
                        vcanvas.setWidth(mainwidth);
                        vcanvas.setHeight(mainheight);
                    }
                }

                let stpointx = parseInt((this.annpoint.XPOINTS * mainwidth) / this.annpoint.WIDTH);
                let stpointy = parseInt((this.annpoint.YPOINTS * mainheight) / this.annpoint.HEIGHT);
                points.push({ x: stpointx, y: stpointy });
                let liveclor = this.annpoint.COLOR;
                let userDetails = getUserDetailsById(streamingPartiIdentity);
                if (
                    [DEVICE_TYPES.ANDROID_BROWSER, DEVICE_TYPES.IOS_BROWSER, DEVICE_TYPES.DESKTOP].includes(userDetails?.device_type) &&
                    ["1", "2", "3"].includes(currentZoom)
                ) {
                    switch (currentZoom) {
                        case "2":
                            pointerScale = 0.7;
                            break;
                        case "3":
                            pointerScale = 0.5;
                            break;
                        case "1":
                        default:
                            pointerScale = 1;
                            break;
                    }
                } else {
                    pointerScale = 1;
                }

                if (points.length > 0) {
                    if (this.remote_pointers[this.userId] == undefined) {
                        this.remote_pointers[this.userId] = this.createPointerShape(stpointx, stpointy, liveclor, pointerScale);
                        vcanvas.add(this.remote_pointers[this.userId]);
                    } else {
                        this.remote_pointers[this.userId].set({ left: stpointx, top: stpointy });
                        this.remote_pointers[this.userId].setCoords();
                    }
                    vcanvas.requestRenderAll();
                }
            }
        }
    }

    /* common function for live pointer for markup and OCR*/
    livePointerOnMarkupOCR = () => {
        const screenshare = reduxStore.getState().twilioEvents.isLocalUserScreenSharing;
        const oppScreenshare = reduxStore.getState().twilioEvents.isOpponentUserScreenSharing;
        const isVideoOn = isvideoenabled();

        // Check if pointer is ON and needs to be turned off
        if (this.checkLivePointerStatus()) {
            // Turn off if any video/screenshare is available
            if (screenshare || oppScreenshare || isVideoOn) {
                this.turnOffLivePointer();
                sendMsgForPointer(STATUS.OFF);
            }
        } else {
            // Pointer is already off, just send DISABLED status
            if (screenshare || (isVideoOn && !oppScreenshare)) {
                sendMsgForPointer(STATUS.DISABLED);
            }
        }
    };

    toggleFeaturesOnPointerOff = () => {
        const { startLocalVideo } = reduxStore.getState().twilioEvents;

        if (PublicVariables.isMobile) {
            zoomService.disablePinchZoom();
            if (!startLocalVideo) {
                setTimeout(() => {
                    zoomService.resetPinchZoom();
                }, 1000);
            }
        }
        reduxStore.dispatch(setIsLocationOnVideoIsVisible(true));
        this.pointerLiveStream = false;
    };

    removeLivePointerColor = (identity) => {
        const { livePointerColors } = reduxStore.getState().livePointer;
        if (livePointerColors.hasOwnProperty(identity)) {
            const updatedColors = { ...livePointerColors };
            delete updatedColors[identity];
            reduxStore.dispatch(setLivePointerColors(updatedColors));
        }
        if (this.remote_pointers.hasOwnProperty(identity)) {
            const updatedRemotePointers = { ...this.remote_pointers };
            vcanvas.setActiveObject(updatedRemotePointers[identity]);
            const activeObj = vcanvas.getActiveObject();
            vcanvas.remove(activeObj);
            vcanvas.requestRenderAll();
            updatedRemotePointers[identity] = undefined;
            this.remote_pointers = updatedRemotePointers;
        }
    };

    enableLivePointerForMobile = (from = "") => {
        const screenshare = reduxStore.getState().twilioEvents.isLocalUserScreenSharing;
        const oppScreenshare = reduxStore.getState().twilioEvents.isOpponentUserScreenSharing;

        // Original condition for mobile button enable message (screen owner controls it)
        if (screenshare || (isvideoenabled() && !oppScreenshare)) {
            sendMsgForPointer(STATUS.ENABLED);
        }

        // Auto-start: trigger when ANY video/screenshare is available (not restricted by owner)
        if (from && (screenshare || oppScreenshare || isvideoenabled())) {
            const autoLivePointerService = require("./autoLivePointerService").default;
            autoLivePointerService.autoStartLivePointer(from);
        }
    };

    // ==================== PROXY METHODS FOR AUTO LIVE POINTER (for backward compatibility) ====================
    // These methods delegate to autoLivePointerService to maintain existing API

    isAutoLivePointerEnabled = () => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        return autoLivePointerService.isAutoLivePointerEnabled();
    };

    autoStartLivePointer = (from, track = null) => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.autoStartLivePointer(from, track);
    };

    autoStartLivePointerAfterMarkupOCR = (from) => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.autoStartLivePointerAfterMarkupOCR(from);
    };

    livePointerAutomaticOnOff = (from) => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.livePointerAutomaticOnOff(from);
    };

    autoPointerOnForSingleStream = () => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.autoPointerOnForSingleStream();
    };

    sendDataTrackForStatusAuto = (from) => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.sendDataTrackForStatusAuto(from);
    };

    checkPointerStartOnMarkupOcrExitForDualStream = () => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.checkPointerStartOnMarkupOcrExitForDualStream();
    };

    checkAutomaticLivePointerOnExpandCollap = (trackArr) => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.checkAutomaticLivePointerOnExpandCollap(trackArr);
    };

    autoPointerOnVideoAndSceenshare = () => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.autoPointerOnVideoAndSceenshare();
    };

    waitForVideoReadyThenExecute = (callback, maxWaitTime = 10000) => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.waitForVideoReadyThenExecute(callback, maxWaitTime);
    };

    assignLivePointerColor = (callback) => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.assignLivePointerColor(callback);
    };

    setLivePointerColors = (identity) => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.setLivePointerColors(identity);
    };

    checkLivePointerForNewParticipant = () => {
        const autoLivePointerService = require("./autoLivePointerService").default;
        autoLivePointerService.checkLivePointerForNewParticipant();
    };
}

export default new LivePointerService();
